/* unplugin-vue-components disabled */import { render } from "./Requisition.vue?vue&type=template&id=51436326&scoped=true&ts=true"
import script from "./Requisition.vue?vue&type=script&lang=ts"
export * from "./Requisition.vue?vue&type=script&lang=ts"

import "./Requisition.vue?vue&type=style&index=0&id=51436326&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51436326"]])

export default __exports__